import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RetroTelevision from "./components/RetroTelevision";

import Home from "./pages/Home";
import Bio from "./pages/Bio";
import Media from "./pages/Media";
import Contact from "./pages/Contact";
import Headshots from "./pages/Headshots";
import Book from "./pages/Book";
import ThunderWriter from "./pages/ThunderWriter";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route element={<RetroTelevision />}>
          <Route path="/" element={<Home />} />
          <Route path="/bio" element={<Bio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/media" element={<Media />} />
          <Route path="/headshots" element={<Headshots />} />
          <Route path="/book" element={<Book />} />
          <Route path="/thunder-writer" element={<ThunderWriter />} />
        </Route>
      </Routes>
    </Router>
  );
}
